import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import Holerites from '../../../components/rh/holerites/apagar';


function DeleteHoleritesScreen () {
    return (
        <Fragment>
            <Head titulo="Apagar Holerites do Mês | Consórcio LVF" />
            <Header />
            <Holerites />
            <Footer />
        </Fragment>
    );
}

export default DeleteHoleritesScreen;